import { createSlice } from "@reduxjs/toolkit";
import {
	langChangeSuccess,
	loadChatsAction,
	loginSuccess,
	loginUser,
	logout,
	lovedChats,
	postImage,
	postMessage,
	signUp,
	submitForm,
	toggleChatLove,
} from "./authenticate.action";

const initialState = {
	isUserSigning: false,
	isUserSignedIn: false,
	isUserFailedToSignIn: false,
	isAuthenticated: false,
	isUserLogingin: false,
	isUserLogedIn: false,
	isUserFailedToLogedIn: false,
	isLoginpending: true,
	isLoginSuccess: false,
	isLogoutPending: false,
	isUserLogedOut: false,
	isUserFialedToLogout: false,
	isLoginSuccessfailed: false,
	isChat: [],
	isUser: null,
	formSkipped: false,
	formSubmitting: false,
	isImagePosting: false,
	isImagePosted: false,
	isImageFailedToPost: false,
	lovedChats: [],
	ischatLoading: true,
	set1Message: {},
	set2Message: {},
	scrollToDown: false,
	streaming: false,
	set1MessageList: [],
	set2MessageList: [],
	pretextSended: "",
	loadChats: false,
	successMessage: "",
	errorMessage: "",
};

const authenticateSlicer = createSlice({
	name: "authenticate",
	initialState: initialState,
	reducers: {
		addChatMessage: (state, action) => {
			state.isChat.push(action.payload);
			state.scrollToDown = true;
		},
		removeChatMessage: (state, action) => {
			state.isChat.pop();
		},
		appleLoginPending: (state, action) => {
			state.isUserLogingin = action.payload;
		},
		appleLoginSuccess: (state, action) => {
			const { chats, user, set1Message, set2Message, set1MessageList, set2MessageList } =
				action.payload;
			state.isLoginpending = false;
			state.isLoginSuccess = true;
			state.isAuthenticated = true;
			state.isChat = chats;
			state.isUser = user;
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.set1MessageList = set1MessageList;
			state.set2MessageList = set2MessageList;
		},
		clearPretextSended: (state, action) => {
			state.pretextSended = action.payload;
		},
		clearCacheAction: (state, action) => {
			state.isChat = action.payload.chats;
			state.set1Message = action.payload.set1Message;
			state.set2Message = action.payload.set2Message;
			state.set1MessageList = action.payload.set1MessageList;
			state.set2MessageList = action.payload.set2MessageList;
		},
		setScrollToDown: (state, action) => {
			state.scrollToDown = action.payload;
		},
		setStreaming: (state, action) => {
			state.streaming = action.payload;
		},
		removeErrorSuccessMessage: (state, action) => {
			state.errorMessage = "";
			state.successMessage = "";
		},
		addErrorMessage: (state, action) => {
			state.errorMessage = action.payload
		},
		formSkipAction: (state, action) => {
			state.formSkipped = action.payload;
		},
	},
	extraReducers: {
		[signUp.pending]: (state) => {
			state.isUserSigning = true;
		},
		[signUp.fulfilled]: (state, action) => {
			const { message } = action.payload;
			state.isUserSigning = false;
			state.successMessage = message;
		},
		[signUp.rejected]: (state, action) => {
			state.isUserSigning = false;
			state.isUserSignedIn = false;
			state.isUserFailedToSignIn = true;
			state.isAuthenticated = false;
			state.errorMessage = action.error.message;
		},
		[loginUser.pendingLogin]: (state) => {
			state.isUserLogingin = true;
		},
		[loginUser.fulfilled]: (state, action) => {
			const { chats, user, set1Message, set2Message, set1MessageList, set2MessageList } =
				action.payload;
			state.isUserLogingin = false;
			state.isUserLogedIn = true;
			state.isAuthenticated = true;
			state.isChat = chats;
			state.isUser = user;
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.scrollToDown = true;
			state.set1MessageList = set1MessageList;
			state.set2MessageList = set2MessageList;
		},
		[loginUser.rejected]: (state) => {
			state.isUserLogingin = false;
			state.isUserLogedIn = false;
			state.isUserFailedToLogedIn = true;
			state.isAuthenticated = false;
		},
		[loginSuccess.pending]: (state) => {
			state.isLoginpending = true;
		},
		[loginSuccess.fulfilled]: (state, action) => {
			const { chats, user, set1Message, set2Message, set1MessageList, set2MessageList } =
				action.payload;
			state.isLoginpending = false;
			state.isLoginSuccess = true;
			state.isAuthenticated = true;
			state.isChat = chats;
			state.isUser = user;
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.scrollToDown = true;
			state.set1MessageList = set1MessageList;
			state.set2MessageList = set2MessageList;
		},
		[loginSuccess.rejected]: (state) => {
			state.isLoginpending = false;
			state.isLoginSuccess = false;
			state.isLoginSuccessfailed = true;
			state.isAuthenticated = false;
			state.errorMessage = "Login Failed";
		},
		[logout.pending]: (state) => {
			state.isLogoutPending = true;
		},
		[logout.fulfilled]: (state) => {
			state.isLogoutPending = false;
			state.isUserLogedOut = true;
			state.isAuthenticated = false;
			state.isChat = [];
			state.isUser = null;
		},
		[langChangeSuccess.fulfilled]: (state, action) => {
			const { user, set1Message, set2Message, chat, set1MessageList, set2MessageList } =
				action.payload;
			state.isUserLogingin = false;
			state.isUserLogedIn = true;
			state.isAuthenticated = true;
			state.isUser = user;
			state.isChat.push(chat);
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.scrollToDown = true;
			state.set1MessageList = set1MessageList;
			state.set2MessageList = set2MessageList;
		},
		[logout.rejected]: (state) => {
			state.isLogoutPending = false;
			state.isUserLogedOut = false;
			state.isUserFialedToLogout = true;
		},
		[postMessage.pending]: (state) => {
			state.isMessagePosting = true;
		},
		[postMessage.fulfilled]: (state, action) => {
			const { userChat, aiChat, set1Message, set2Message, pretextSended } = action.payload;

			if (aiChat) {
				const startReplaceIndex = state.isChat.length - 2;
				state.isChat.splice(startReplaceIndex, 2, userChat, aiChat);
			} else {
				const startReplaceIndex = state.isChat.length - 2;
				state.isChat.splice(startReplaceIndex, 1, userChat);
				state.isChat.pop();
			}

			state.isMessagePosting = false;
			state.isMessagePosted = true;
			state.set1Message = set1Message;
			state.set2Message = set2Message;
			state.scrollToDown = true;
			state.streaming = true;
			state.pretextSended = pretextSended;
		},
		[postMessage.rejected]: (state) => {
			state.isMessagePosting = false;
			state.isMessagePosted = false;
			state.isMessageFailed = false;
			state.isChat.pop();
		},
		[postImage.pending]: (state) => {
			state.isImagePosting = true;
		},
		[postImage.fulfilled]: (state, action) => {
			const { userChat, aiChat } = action.payload;

			const startReplaceIndex = state.isChat.length - 2;
			state.isChat.splice(startReplaceIndex, 2, userChat, aiChat);

			state.isImagePosting = false;
			state.isImagePosted = true;
			state.scrollToDown = true;
		},
		[postImage.rejected]: (state) => {
			state.isImagePosting = false;
			state.isImagePosted = false;
			state.isImageFailedToPost = true;
			state.isChat.pop();
		},
		[toggleChatLove.fulfilled]: (state, action) => {
			const chatIndex = state.isChat.findIndex(
				(chat) => chat._id === action.payload.chat._id
			);
			const lovedChatIndex = state.lovedChats.findIndex(
				(chat) => chat._id === action.payload.chat._id
			);

			if (chatIndex !== -1) {
				state.isChat[chatIndex] = action.payload.chat;
			}

			if (lovedChatIndex !== -1) {
				state.lovedChats.splice(lovedChatIndex, 1);
			} else {
				state.lovedChats.push(action.payload.chat);
			}
		},
		[lovedChats.fulfilled]: (state, action) => {
			state.lovedChats = action.payload.chats;
			state.ischatLoading = false;
		},
		[lovedChats.pending]: (state) => {
			state.ischatLoading = true;
		},

		[loadChatsAction.pending]: (state) => {
			state.loadChats = true;
		},
		[loadChatsAction.fulfilled]: (state, action) => {
			const { chats } = action.payload;

			if (chats.length > 0) {
				state.isChat.unshift(...chats);
			}

			state.loadChats = false;
		},
		[loadChatsAction.rejected]: (state) => {
			state.loadChats = false;
		},
		[submitForm.pending]: (state) => {
			state.formSubmitting = true;
		},
		[submitForm.fulfilled]: (state, action) => {
			const { user } = action.payload;

			state.isUser = user;
		},
		[submitForm.rejected]: (state) => {
			state.formSubmitting = false;
			state.errorMessage = "Error Submitting Verification Form";
		},
	},
});

export const {
	addChatMessage,
	addErrorMessage,
	removeChatMessage,
	appleLoginSuccess,
	appleLoginPending,
	replaceLovedChat,
	clearCacheAction,
	setScrollToDown,
	setStreaming,
	clearPretextSended,
	formSkipAction,
	removeErrorSuccessMessage,
} = authenticateSlicer.actions;
export default authenticateSlicer.reducer;
